export default "__VITE_ASSET__kWiD5eqm__"